import React from 'react'
import PropTypes from 'prop-types'
import { Field, FieldArray, getIn } from 'formik'
import classNames from 'classnames'
import * as S from '../../Checkbox/styled'

import { Help } from '@peracto/peracto-ui'
import FormError from '../Error'

const CheckboxGroup = ({ name, label, help = false, className, options, ...props }) => {
    return (
        <Field name={name}>
            {({ field, form }) => {
                let error = getIn(form.errors, name)

                if (error) {
                    const errorFieldName = label ? label : 'This'
                    error = error.replace(field.name, errorFieldName)
                }

                props.className = classNames('form-control', className)

                if (help) {
                    props['aria-describedby'] = `${name}Help`
                }

                if (!field.value) {
                    field.value = []
                }

                return (
                    <FieldArray name={field.name}>
                        {({ push, remove }) => (
                            <div
                                className={classNames('form-group', {
                                    'has-error': error,
                                })}
                            >
                                {label.length > 0 && <label className="!mb-0">{label}</label>}
                                {options.map((option, idx) => (
                                    <React.Fragment key={`${field.name}-${idx}`}>
                                        <S.Checkbox htmlFor={option.value}>
                                            <input
                                                id={option.value}
                                                type="checkbox"
                                                value={field.value.includes(option.value)}
                                                onChange={e => {
                                                    const target = e.currentTarget

                                                    if (target.checked) {
                                                        push(target.id)
                                                    } else {
                                                        remove(idx, 1)
                                                    }
                                                }}
                                                className={className}
                                                data-value={field.value}
                                                disabled={form.isSubmitting || props.disabled}
                                            />

                                            <span className="checkbox"></span>

                                            {option.label.length > 0 && option.label}
                                        </S.Checkbox>
                                        {option.help && (
                                            <Help id={`${option.value}Help`} help={option.help} />
                                        )}
                                    </React.Fragment>
                                ))}

                                {help && <Help id={`${name}Help`} help={help} />}

                                {error && <FormError error={error} />}
                            </div>
                        )}
                    </FieldArray>
                )
            }}
        </Field>
    )
}

CheckboxGroup.displayName = 'CheckboxGroup'

CheckboxGroup.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    help: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    className: PropTypes.string,
}

export default CheckboxGroup
